<!--
 * @Author: lishiqiao
 * @Date: 2021-12-22 15:51:45
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-10-25 14:26:33
-->
<template>
  <div class="case-details">
    <div class="details-box">
      <div
        class="title"
        v-if="customerCaseList.length !== 0"
      >
        {{ customerCaseList[0].caseName }}
      </div>
      <div
        class="close-icon"
        @click="close"
      >
        <svg
          version="1.1"
          id="图层_2"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 44.9 42.3"
          style="enable-background: new 0 0 44.9 42.3"
          xml:space="preserve"
        >
          <g>
            <image
              style="overflow: visible; opacity: 0.2"
              width="57"
              height="58"
              xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA7CAYAAAAq55mNAAAACXBIWXMAAAsSAAALEgHS3X78AAAA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"
              transform="matrix(1 0 0 1 -4.9782 -7.0512)"
            ></image>
            <g>
              <path
                class="st0"
                d="M34.7,28.6l-7.5-7.5l7.5-7.5c1.3-1.3,1.3-3.5,0-4.8l0,0c-1.3-1.3-3.5-1.3-4.8,0l-7.5,7.5l-7.5-7.5
			c-1.3-1.3-3.5-1.3-4.8,0l0,0c-1.3,1.3-1.3,3.5,0,4.8l7.5,7.5l-7.5,7.5c-1.3,1.3-1.3,3.5,0,4.8l0,0c1.3,1.3,3.5,1.3,4.8,0l7.5-7.5
			l7.5,7.5c1.3,1.3,3.5,1.3,4.8,0l0,0C36.1,32.1,36.1,29.9,34.7,28.6z"
              />
            </g>
          </g>
        </svg>
      </div>
      <div
        class="details-content"
        v-if="customerCaseList.length !== 0"
      >
        <div class="details">
          <img
            :src="customerCaseList[0].mainPicture"
            lazy-load
            class="details-left"
          />
          <div class="details-right">
            <div class="small-img">
              <img
                :src="customerCaseList[0].detailPicture1"
                lazy-load
              />
              <img
                :src="customerCaseList[0].detailPicture2"
                lazy-load
              />
            </div>
            <div :class="['case-content-box', lang=='zh'?'zh':'en']">
              <div class="text-box background">
                <div class="text-title">{{ $t("case.background") }} ：</div>
                <div
                  class="text-content"
                  v-lazy-container="{selector: 'img'}"
                  v-html="customerCaseList[0].projectBackground"
                ></div>
              </div>
              <div class="text-box problem">
                <div class="text-title">{{ $t("case.resolved") }} ：</div>
                <div
                  class="text-content"
                  v-lazy-container="{selector: 'img'}"
                  v-html="customerCaseList[0].solveProblem"
                ></div>
              </div>
            </div>

            <!-- 名优现代渔业产业园vr -->
            <a
              v-if="customerCaseList[0].id=='1478247104871735297'"
              style="display: inline-block;margin-top: 15px;
                    width: 100%;
                    text-align: center;font-family: AlibabaPuHuiTi-Regular;"
              :href="parkurl"
              target="_blank"
            >查看名优现代渔业产业园VR全景</a>
            <!-- 湛江市湛渔深海网箱项目vr -->
            <a
              v-if="customerCaseList[0].id=='1473532849818308610'"
              style="display: inline-block;
                    margin-top: 15px;
                    width: 100%;
                    text-align: center;font-family: Alibaba-PuHuiTi-Medium;font-family: AlibabaPuHuiTi-Regular;"
              :href="zhanyuurl"
              target="_blank"
            >查看湛江市湛渔深海网箱项目VR全景</a>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../../axios/index.js";
export default {
  name: "caseDetails",
  components: {},
  directives: {},
  data() {
    return {
      lang: this.$i18n.locale,
      params: {
        page: 1,
        pageSize: 15,
        orders: { sequence: "desc" },
        param: {
          id: "",
          lang: "zh_CN",
        },
      },
      customerCaseList: [{ caseName: "" }],
      parkurl: "http://park-vr.uyu1027.com",
      zhanyuurl: "http://zhanyu-vr.uyu1027.com",
    };
  },
  props: {
    msg: String,
  },
  created() {
    if (this.$i18n.locale === "zh") {
      this.params.param.lang = "zh_CN";
    } else if (this.$i18n.locale === "en") {
      this.params.param.lang = "en";
    }
    this.customerCaseList = [];
    this.params.param.id = this.$route.query.id;
    this.getCustomerCaseList();
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (newValue === "zh") {
        this.params.param.lang = "zh_CN";
      } else {
        this.params.param.lang = "en";
      }
      this.customerCaseList = [];
      this.getCustomerCaseList();
    },
  },
  methods: {
    // 获取详情信息
    getCustomerCaseList() {
      const url = `/frontCustomerCase/page`;
      http
        .post(url, this.params)
        .then((res) => {
          if (res.code === "00000") {
            this.customerCaseList = res.data.list;
            // 使用vue-lazyload,所有的img标签的src属性改为data-src
            this.customerCaseList[0].projectBackground =
              this.customerCaseList[0].projectBackground.replace(
                /src/g,
                "data-src"
              );
            this.customerCaseList[0].solveProblem =
              this.customerCaseList[0].solveProblem.replace(/src/g, "data-src");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    close() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.case-details {
  box-sizing: border-box;
  position: relative;
  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .details-box {
    position: relative;
    width: 116.75rem;
    height: 63.75rem;
    margin-top: -0.33rem;

    .title {
      box-sizing: border-box;
      font-size: 1.74rem;
      //font-family: Alibaba PuHuiTi;
      font-family: Alibaba-PuHuiTi-Medium;
      font-weight: 500;
      color: #2b2b2b;
      line-height: 1.67rem;
      position: absolute;
      left: 0;
      right: 0;
      //top: 0.9rem;
      top: 1.3rem;
    }

    .close-icon {
      position: absolute;
      right: 1.76rem;
      top: 4.67rem;
      svg {
        width: 2.25rem;
        height: 2.25rem;

        .st0 {
          fill: #ffffff;
        }
      }
    }

    .details-content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      margin-top: 13.83rem;

      .details {
        box-sizing: border-box;
        display: flex;

        .details-left {
          box-sizing: border-box;
          width: 56.25rem;
          height: 40.42rem;
          border-radius: 0.83rem;
          margin-right: 2.17rem;
        }

        .details-right {
          box-sizing: border-box;
          width: 41.92rem;
          height: 40.42rem;

          .small-img {
            box-sizing: border-box;
            width: 100%;
            height: 12.58rem;
            display: flex;
            justify-content: space-between;
            margin-bottom: 2.66rem;

            img {
              width: 20.08rem;
              height: 12.58rem;
              border-radius: 0.83rem;
            }
          }
          .case-content-box {
            overflow-y: auto;
            height: 63%;
            width: max-content;
            width: 103%;

            &.zh {
              line-height: 2rem;
              letter-spacing: 0.29rem;
            }
            &.en {
              word-break: keep-all;
            }
            /*滚动条整体样式*/
            &::-webkit-scrollbar {
              width: 0.27rem;
              // height: 4px;
            }
            /*滚动条里面小方块*/
            &::-webkit-scrollbar-thumb {
              background: #929292;
              border-radius: 0.5rem;
              height: 0.5rem;
            }
            // /*滚动条里面轨道*/
            &::-webkit-scrollbar-track {
              background: #d9d9d9;
              border-radius: 20rem;
            }
          }

          .text-box {
            box-sizing: border-box;
            width: 41.5rem;
            height: auto;
            padding-left: 0.42rem;
            text-align: left;

            .text-title {
              font-size: 1.33rem;
              //font-family: Alibaba PuHuiTi;
              font-family: Alibaba-PuHuiTi-Medium;
              font-weight: bold;
              color: #2b2b2b;
              margin-bottom: 0.83rem;
              margin-top: -0.33rem;
              //line-height: 1.25rem;
            }

            .text-content {
              font-size: 1.17rem;
              //font-family: Alibaba PuHuiTi;
              font-family: Alibaba-PuHuiTi-Medium;
              font-weight: 500;
              color: #2b2b2b;
              //line-height: 2rem;
              //letter-spacing: 0.29rem;
              text-align: justify;
            }
          }

          .problem {
            margin-top: 2.5rem;
          }
        }
      }
    }
  }
}
</style>
